import notificationTemplate from '../templates/notification.hbs';
import $ from 'jquery';
import AppContext from '@sinclair-digital/sbg-storyline-sdk/lib/storyline/AppContext';
import {path} from 'ramda';

const closeNotification = $notification => {
    $notification.removeClass('sda-notification-visible');
    setTimeout(() => $notification.remove(), 675);
};

const getFeatureFlagOr = (featureFlagName, defaultValue = false) => {
    if (typeof window !== 'undefined') {
        const userModel = path(['_debugModel', 'userModel'], window);
        if (userModel) {
            const appContext = new AppContext({userModel});
            const ffValue = appContext.getFeatureFlag(featureFlagName);
            if (typeof ffValue !== 'undefined') {
                return ffValue;
            }
        }
    }
    return defaultValue;
};

let shown = [];
const defaultTimeout = 6000;
const maxShown = 3;

function cleanShown() {
    const now = Date.now();
    shown = shown.filter(notification => {
        if (notification.until > now) {
            return true;
        }
        closeNotification(notification);
        return false;
    });
    if (shown.length <= maxShown) {
        return;
    }
    shown.slice(0, -maxShown).forEach(closeNotification);
    shown = shown.slice(-maxShown);
}

// messageType :: 'info' | 'success' | 'error'
// messageHandler :: (messageType, String, String?) -> ()
export const messageHandler = (type, primaryMessage, secondaryMessage = '') => {
    const $notification = $(
        notificationTemplate(
            {
                type,
                primaryMessage,
                secondaryMessage,
                isError: type === 'error',
                showLink: getFeatureFlagOr('storyline_ui.message_handler.show_link', false),
            }
        )
    );

    $('.sda-app-notifications').append($notification);
    $notification.find('.sda-notification-close').on('click', closeNotification.bind(null, $notification));
    setTimeout(() => $notification.addClass('sda-notification-visible'), 50);
    const autoclose = type !== 'error';
    $notification.until = autoclose ? Date.now() + defaultTimeout : Infinity;

    shown.push($notification);
    if (autoclose) {
        setTimeout(cleanShown, defaultTimeout);
    }
    if (shown.length > maxShown) {
        cleanShown();
    }
};

export default {
    messageHandler,
};
